import { useParams } from 'react-router-dom';
import { createColumnHelper } from '@tanstack/react-table';
import { BookingTable } from '@services/member/booking/booking.types';

export const useDetailsBookingsVM = () => {
    const { id } = useParams();
    const bookingColumnHelper = createColumnHelper<BookingTable>();
    
    return {
        id,
        bookingColumnHelper
    };
};
